// Preparo de fotos no cliente: valida 5MB POR ARQUIVO (original) e comprime p/ ~500KB antes do envio.
const MAX_MB = 5;
const ALVO_KB = 500;
const MAX_DIM = 1600;
export const MSG_5MB = "Arquivo muito grande. Por favor, envie uma foto com até 5MB";

export async function prepararFoto(file, opts = {}) {
  const { maxDim = MAX_DIM, alvoKB = ALVO_KB, minQ = 0.45 } = opts;
  if (!file) return file;
  const ehImagem = (file.type || "").startsWith("image/") ||
    /\.(jpe?g|jfif|png|webp|heic|heif)$/i.test(file.name || "");
  if (!ehImagem) return file;
  if (file.size > MAX_MB * 1024 * 1024) {
    const err = new Error(MSG_5MB);
    err.userMessage = MSG_5MB;
    throw err;
  }
  try {
    const bmp = await createImageBitmap(file);
    const escala = Math.min(1, maxDim / Math.max(bmp.width, bmp.height));
    const canvas = document.createElement("canvas");
    canvas.width = Math.max(1, Math.round(bmp.width * escala));
    canvas.height = Math.max(1, Math.round(bmp.height * escala));
    canvas.getContext("2d").drawImage(bmp, 0, 0, canvas.width, canvas.height);
    if (bmp.close) bmp.close();
    let blob = null;
    for (let q = 0.85; q >= minQ - 0.001; q -= 0.1) {
      blob = await new Promise((r) => canvas.toBlob(r, "image/jpeg", q));
      if (blob && blob.size <= alvoKB * 1024) break;
    }
    if (blob && blob.size < file.size) {
      const nome = (file.name || "foto").replace(/\.[^.]+$/, "") + ".jpg";
      return new File([blob], nome, { type: "image/jpeg" });
    }
  } catch {
    // HEIC/HEIF podem não decodificar no navegador — o backend converte e comprime
  }
  return file;
}
